import store from "_private/store";
import Cookie from "js-cookie";

const USER = "user";

class Auth {
    setUserInfoAct(userInfo) {
        var time;
        if(userInfo.remberMeTime!=null&&userInfo.remberMeTime<=0){
            time=1;
        }else{
            time=userInfo.remberMeTime;
        }
        Cookie.set(USER, JSON.stringify(userInfo), { expires: time });
    }

    getUserInfo() {
        // cookie 获取不存在的 key 返回 undefined
        let user = Cookie.get(USER);
        return JSON.parse(user ? user : "{}");
    }

    removeStore() {
        // 移除 vuex 数据
        store.dispatch("setUserInfoAct", {});
        store.commit("SET_ROUTERS", []);
        store.commit("SET_MENUS", []);
    }

    removeUserInfo() {
        this.removeStore();
        Cookie.remove(USER);
    }

    isAuthenticated() {
        let user = this.getUserInfo();
        if (user !== null && user.userId !== undefined) {
            return true;
        }
        return false;
    }
}

export default new Auth();
